// extracted by mini-css-extract-plugin
export var quantityInput = "_fh-0";